import { Box } from '@mui/material';
import React from 'react';
import { useDroppable } from '@dnd-kit/core';
import { OrderData } from '../../api';
import { UNASSIGNED_ID } from '../views/dragndrop/DragDropTypes';

export type GeneratedResource = {
  id: string;
  name: string;
  index: number;
  schedulerConfigId: string;
};

type ResourceColumnProps = {
  resource: GeneratedResource | null;
  orders: Array<OrderData & { css: any }>;
  columnWidth: number;
  leftPosition: number;
  openOrder: (event: any, order: OrderData) => void;
};

export const ResourceColumn = ({ resource, orders, columnWidth, leftPosition, openOrder }: ResourceColumnProps) => {
  const { setNodeRef, isOver } = useDroppable({
    id: resource?.id || UNASSIGNED_ID,
  });

  return (
    <Box
      id={'mmm'}
      ref={setNodeRef}
      sx={{
        width: `${columnWidth}%`,
        left: `${leftPosition}%`,
        height: 50 * 17,
        position: 'absolute',
        borderRight: '1px solid #e0e0e0',
        backgroundColor: isOver ? 'rgba(0, 255, 0, 0.1)' : 'transparent',
        borderInlineStart: '1px solid #E6E6E6',
      }}>
      {/* This column is just for drop zones - orders are rendered separately */}
    </Box>
  );
};
